var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"add-book"},[(_vm.book)?_c('BookForm',{attrs:{"useBook":_vm.book,"isAdmin":""}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }